<template>
  <div class="orders-card">
    <div class="orders-icon">
      <i class="fas fa-shopping-bag"></i>
    </div>
    <div class="orders-content">
      <h2 class="orders-title">Total orders this month</h2>
      <div class="orders-amount">{{ totalOrders }}</div>
    </div>
  </div>
</template>
  
<script>
export default {
  name: 'OrdersCard',
  props: {
    totalOrders: String,
  }
};
</script>
  
<style scoped>
.orders-card {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  display: flex;
  align-items: center;
  flex: 1;
  transition: transform 0.2s, box-shadow 0.2s;
  height: 100%;
}

.orders-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.orders-icon {
  background-color: #4C6B30;
  color: white;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  margin-right: 1.5rem;
}

.orders-content {
  display: flex;
  flex-direction: column;
}

.orders-title {
  font-size: 1.1rem;
  color: #666;
  margin: 0 0 0.5rem 0;
  font-weight: normal;
}

.orders-amount {
  font-size: 2rem;
  font-weight: 700;
  color: #333;
}

/* Media Queries for responsiveness */
@media (max-width: 768px) {
  .orders-card {
    padding: 1.25rem;
  }
  
  .orders-icon {
    width: 40px;
    height: 40px;
    font-size: 1.2rem;
    margin-right: 1rem;
  }

  .orders-title {
    font-size: 1rem;
  }

  .orders-amount {
    font-size: 1.5rem;
  }
}

@media (max-width: 480px) {
  .orders-card {
    padding: 1rem;
    flex-direction: column;
    text-align: center;
  }

  .orders-icon {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .orders-title {
    font-size: 0.9rem;
  }

  .orders-amount {
    font-size: 1.2rem;
  }
}
</style>
